<template>
  <div>
    <div class="row-item" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        :loading="loading[shop.id]"
        value-key="templateId"
        name-key="name"
        clearable
        @visible-change="isShow => visibleSelect(isShow, shop)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="item in optionsMap[shop.id]" :key="item.templateId" :label="item.name" :value="item"> </el-option>
      </el-select>
      <span v-if="getFail[shop.id]" style="color: red;margin-left: 10px; font-size: 12px;">店铺授权已失效</span>
    </div>
  </div>
</template>

<script>
import { getXhsCarriageTemplateList } from '@/servers/prod/center/xhs.js';

import _ from 'lodash';
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      valueMap: {},
      optionsMap: {},
      getFail: {},
      loading: {},
      initValueMaped: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.valueMap = {};
        (v || []).forEach(item => {
          const { shopId, templateId, name } = item || {};
          if (shopId && templateId) {
            this.$set(this.valueMap, shopId, item);
          }
        });
        if (!this.initValueMaped) { // 只在第一次加载的时候判断，如果没值，默认选中第一个
          this.initValueMaped = true;
          this.shopList.forEach(shop => {
            if (!this.valueMap[shop.id]?.name) {
              this.getList(shop);
            }
          });
        }
      },
    },
  },
  methods: {
    visibleSelect(isShow, shop) {
      if (!isShow) return;
      if (!this.optionsMap[shop.id]?.length) {
        this.getList(shop);
      }
    },
    selectChange(v, shopId) {
      this.valueMap[shopId] = v;
      this.valueChange();
    },
    valueChange() {
      const valueList = Object.values(this.valueMap).filter(Boolean);
      this.$emit('change', valueList);
    },
    // 获取
    async getList(shop) {
      if(![2, 3].includes(shop.state)) return
      try {
        const shopId = shop.id;
        this.$set(this.loading, shopId, true);
        const data = await getXhsCarriageTemplateList({ shopId }, { isNeedFailNotice: true });
        this.loading[shopId] = false;
        this.$set(this.getFail, shopId, !data);
        let carriageTemplateList = data?.carriageTemplateList || [];
        if (!carriageTemplateList.length) return;
        const list = carriageTemplateList.map(item => {
          return {
            shopId,
            templateId: item.templateId,
            name: item.templateName,
          };
        });

        if (this.valueMap[shopId]) {
          const findItem = list.find(item => item.templateId === this.valueMap[shopId].templateId);
          this.$set(this.valueMap, shopId, findItem || list[0]);
        } else {
          this.$set(this.valueMap, shopId, list[0]);
        }
        this.valueChange();
        this.$set(this.optionsMap, shopId, list);
      } catch (error) {
        console.log(error, '-----error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>